import styles from './../styles/header.module.scss';
import logo from './../img/logo_azul.svg';
import logoResponsive from './../img/logo-balvanera.svg';
import React from 'react';
import { Row, Col } from 'reactstrap';

const Header = (props) => {
  return (
    <div>
      <Row className={styles.headerLogo + ' mx-0 d-none d-lg-flex'}>
        <Col md="3" className="text-center p-0">
          <img src={logo} alt="logo" className={styles.imgLogo + ' img-fluid lazyload'}></img>
        </Col>
      </Row>
      <div className={styles.headerLogoResponsive + ' d-lg-none text-center'}>
        <img
          src={logoResponsive}
          alt="logo"
          className={styles.imgLogoResponsive + ' img-fluid p-3 px-5 lazyload'}
        />
      </div>
    </div>
  );
};

export default Header;
